import apiV1, { getApiPrefix } from "@common/lib/api";
import { type I18n } from "@common/lib/i18n";
import { type DynamicData } from "../../components/Bank/Recipient/AddUpdateModal";
import { type Account } from "./types";

const createApi = (i18n: I18n, isHost: boolean) => {
  const baseUrl = `${getApiPrefix(isHost)}/bank/accounts`;
  const baseProcessUrl = `${getApiPrefix(isHost)}/bank/process`;

  return {
    addAccount: (data: Account.Api.CreateAccountRequest): Promise<Account.Api.Account> =>
      apiV1.post(i18n, `${baseUrl}`, data),

    getAccount: (id: string): Promise<Account.Api.Account> => apiV1.get(i18n, `${baseUrl}/${id}`),

    getAccounts: (args: Account.Api.GetAccountRequest): Promise<Account.Api.Account[]> =>
      apiV1.get(i18n, `${baseUrl}`, args),

    lookupAccount: (number: number): Promise<Account.Api.LookupAccount> =>
      apiV1.get(i18n, `${baseUrl}/lookup/${number}`),

    updateAccount: (data: Account.Api.UpdateAccountRequest): Promise<Account.Api.Account> =>
      apiV1.put(i18n, `${baseUrl}`, data),

    depositToAccount: (id: string, data: Account.Api.DepositRequest): Promise<Account.Api.AccountTransaction> =>
      apiV1.post(i18n, `${baseUrl}/${id}/deposit`, data),

    transfer: (id: string, data: Account.Api.TransferRequest): Promise<Account.Api.AccountTransaction> =>
      apiV1.post(i18n, `${baseUrl}/${id}/transfer`, data),

    withdrawWithOtp: (id: string, data: Account.Api.WithdrawRequest): Promise<Account.Api.WithdrawResponse> =>
      apiV1.post(i18n, `${baseUrl}/${id}/withdraw`, data),

    getAccountTransaction: (id: string, tid: string): Promise<Account.Api.AccountTransaction> =>
      apiV1.get(i18n, `${baseUrl}/${id}/transactions/${tid}`),

    getTransactions: (args: Account.Api.GetAccountTransactionRequest): Promise<Account.Api.AccountTransaction[]> =>
      apiV1.get(i18n, `${baseUrl}/transactions`, args),

    getAccountTransactions: (
      id: string,
      args: Account.Api.GetAccountTransactionRequest
    ): Promise<Account.Api.AccountTransaction[]> => apiV1.get(i18n, `${baseUrl}/${id}/transactions`, args),

    getBeneficiaryDynamicData: (data: Account.Api.GetBeneficiaryDynamicDataRequest): Promise<DynamicData> =>
      apiV1.post(i18n, `${getApiPrefix(isHost)}/bank/beneficiaries/dynamic/data`, data),

    exportTransactions: (accountId: string, date: Date): Promise<void> =>
      apiV1.get(i18n, `${baseUrl}/${accountId}/export/transactions`, { date }),

    getSettings: (): Promise<Account.Api.Settings> =>
      apiV1.get(i18n, `${getApiPrefix(isHost)}/api/admin/v1/settings/wallet`),
    updateSettings: (data: Account.Api.UpdateSettingsRequest): Promise<void> =>
      apiV1.put(i18n, `${getApiPrefix(isHost)}/api/admin/v1/settings/wallet`, data),

    processTransfer: (data: Account.Api.ProcessTransferRequest): Promise<void> =>
      apiV1.put(i18n, `${baseProcessUrl}/transfer`, data)
  };
};

export const getApi = (i18n: I18n, isHost?: boolean) => (isHost ? createApi(i18n, true) : createApi(i18n, false));
